import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export class OfferAccessFormGroup extends UntypedFormGroup implements OfferAccessFormGroupInterface {
  public controls: OfferAccessControls;
  constructor() {
    super({
      allowed: new UntypedFormControl([]),
      denied: new UntypedFormControl([]),
    });
  }
}

interface OfferAccessFormGroupInterface extends UntypedFormGroup {
  controls: OfferAccessControls;
}

type OfferAccessControls = {
  allowed: AbstractControl;
  denied: AbstractControl;
};
